module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAAIVBMVEX///9gZHD7+/vT1NhzdoFydoDg4eOtr7bP0dTBwse8vcItGjiwAAAAP0lEQVQY02NgYDAVhIFgBhBwhPNFwHxBEAFh0YYPBzj4SjCArn+Q8Mlxv6UCinlsggV4+QxdCtjsx4wv9PgEAPq/Dmw5oEipAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/storagedetail/img/tel.png
// module id = 745
// module chunks = 0